import 'unfetch/polyfill'
import LazyLoadImages from './lazy-load'
import Sentry from './sentry'
import AsyncStyles from './async-styles'
import HeaderLogin from './header-login/header-login-builder'
import ClientEducationLibrary from './client-education-library'
import ShareArticleModal from './client-education-library/shareArticleModal'
import CTATrack from './cta'
import EarthDayHeader from './earth-day'
import PageGreatPetPicks from './great-pet-picks'
import MobileMenu from './menu/mobile'
import PetLandbot from './pet-landbot'
import PetNameTool from './pet-names-tool'
import PostsLoadMore from './posts'
import ProductSticky from './product-sticky'
import RelatedArticles from './related-articles'
import ShowPosts from './shortcodes/show-posts'
import Sliders from './sliders'
import TableOfContents from './table-of-contents'
import ResponsiveVideos from './videos'
import WorkWithUs from './work-with-us'
import FirstSeenEvent from './first-seen-event'
import ProductPage from './product-page'
import CareCredit from './care-credit'
import CareCreditLoadMore from './care-credit/load-more'
import CareCreditCostCalculator from './care-credit/cost-calculator'
import PaidClicksTracking from './paid-clicks-tracking'
import RoyalCanin from './royal-canin'
import UtmParameters from './utm-parameters'
import PidCookie from './pid'
import NexGard from './nexgard'
import Cyberweek from './cyberweek'
import ObesityCenter from './obesity-center'
import FleaTickHeartwormPreventionCenter from './flea-tick-heartworm-prevention-center'
import PetGuideCenter from './pet-guide-center'
import ContactHelpSelect from './contact-help-select'
import NewPetCostCalculator from './new-pet/cost-calculator'

HeaderLogin()
LazyLoadImages()
Sentry()
MobileMenu()
ShowPosts()
TableOfContents()
ResponsiveVideos()
PetLandbot()
PetNameTool()
AsyncStyles()
PostsLoadMore()
CTATrack()
EarthDayHeader()
RelatedArticles()
Sliders()
PageGreatPetPicks()
ProductSticky()
WorkWithUs()
ClientEducationLibrary()
ShareArticleModal()
FirstSeenEvent()
ProductPage()
CareCredit()
CareCreditLoadMore()
CareCreditCostCalculator()
PaidClicksTracking()
RoyalCanin()
NexGard()
Cyberweek()
ObesityCenter()
FleaTickHeartwormPreventionCenter()
PetGuideCenter()
UtmParameters()
PidCookie()
ContactHelpSelect()
NewPetCostCalculator()
